import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import Dettagli from "./DettagliManVenAR";
import axios from "axios";

function WithHeaderStyledExample() {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const [quantityOrdered2023, setQuantityOrdered2023] = useState(0);
  const [quantityOrdered2024, setQuantityOrdered2024] = useState(0);
  const [percentuale, setPercentuale] = useState("");

  const [mancataVenditaMedia, setMancataVenditaMedia] = useState({});
  const [mancataVenditaAttuale, setMancataVenditaAttuale] = useState({});
  const [percentualeValore, setPercentualeValore] = useState("");
  const [percentualeQta, setPercentualeQta] = useState("");
  const [percentualeNumCli, setPercentualeNumCli] = useState("");
  const [percentualeDisponibile, setPercentualeDisponibile] = useState("");

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

 const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  const getDateRange = () => {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    const lastYear = currentYear - 1;
    const pad = (n) => (n < 10 ? "0" + n : n);
    const formattedMonth = pad(currentMonth);
    const formattedDay = pad(today.getDate());

    return {
      currentDateRange: `01/${formattedMonth}/${currentYear} - ${formattedDay}/${formattedMonth}/${currentYear}`,
      lastYearDateRange: `01/${formattedMonth}/${lastYear} - ${formattedDay}/${formattedMonth}/${lastYear}`
    };
  };

  const { currentDateRange, lastYearDateRange } = getDateRange();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const { mese, mancata_vendita } = res.data.AR;

        const entry2023 = mese.find((e) => e.anno === "2025");
        const entry2024 = mese.find((e) => e.anno === "2026");
        if (entry2023) setQuantityOrdered2023(entry2023.valore_ordinato);
        if (entry2024) setQuantityOrdered2024(entry2024.valore_ordinato);

        if (entry2023 && entry2024) {
          const change = ((entry2024.valore_ordinato - entry2023.valore_ordinato) / entry2023.valore_ordinato) * 100;
          setPercentuale(change.toFixed(2));
        }

        if (mancata_vendita) {
          setMancataVenditaMedia(mancata_vendita.media);
          setMancataVenditaAttuale(mancata_vendita.attuale);
          const calcPerc = (curr, med) => med ? ((curr - med) / med * 100).toFixed(2) : "0";
          setPercentualeValore(calcPerc(mancata_vendita.attuale.valore, mancata_vendita.media.valore));
          setPercentualeQta(calcPerc(mancata_vendita.attuale.qta, mancata_vendita.media.qta));
          setPercentualeNumCli(calcPerc(mancata_vendita.attuale.num_cli, mancata_vendita.media.num_cli));
          setPercentualeDisponibile(calcPerc(mancata_vendita.attuale.ricercato_disponibile, mancata_vendita.media.ricercato_disponibile));
        }
        setIsLoading(false);
      } catch (error) {
        setIsError(true);
      }
    };
    fetchData();
  }, []);

  const renderTrend = (perc, inverse = false) => {
    if (perc === "") return null;
    const val = parseFloat(perc);
    const isNeg = val < 0;
    const color = inverse ? (val > 0 ? "#dc3545" : "#198754") : (isNeg ? "#dc3545" : "#198754");
    return (
      <span className="fw-bold d-flex align-items-center gap-1 text-nowrap" style={{ color: color, fontSize: "0.75rem" }}>
        {perc}% {isNeg ? <FaArrowTrendDown /> : <FaArrowTrendUp />}
      </span>
    );
  };

  return (
    <>
      <Card
        className="card bg-dark ombra ordini-ora card-home hover-effect border-0 am-summary-card am-orders-detail-card"
        style={{ borderRadius: "15px", padding: "1.2rem", cursor: 'pointer' }}
        onClick={handleShowModal}
      >
        <Card.Body className="p-0 am-summary-body"> {/* Padding rimosso qui per gestirlo nel wrapper scrollabile */}
          
          {/* WRAPPER SCROLLABILE: Si attiva sotto i 300px */}
          <div className="responsive-scroll-container">
            <div style={{ minWidth: "260px" }}> {/* Impedisce il collasso degli elementi interni */}
              
              {/* Header */}
              <div className="mb-3">
                <p className="text-title2 fw-bold mb-1 text-nowrap" style={{ fontSize: "0.85rem", letterSpacing: "0.5px" }}>
                  DETTAGLI ORDINI
                </p>
                <small className="text-light text-nowrap d-block" style={{ fontSize: "0.6rem" }}>
                  {currentDateRange} vs {lastYearDateRange}
                </small>
              </div>

              {/* Confronto Annuale */}
              <div className="d-flex flex-column gap-2 mb-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                  <span className="fw-bold text-light small text-nowrap">TOTALE 2026</span>
                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-bold text-light mb-0" style={{fontSize: '1.1rem'}}>{formatToEuro(quantityOrdered2024)}</span>
                    {renderTrend(percentuale)}
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-secondary small fw-bold">TOTALE 2025</span>
                  <span className="text-secondary small fw-bold">{formatToEuro(quantityOrdered2023)}</span>
                </div>
              </div>

              {/* Sezione Mancata Vendita */}
              <div className="p-2 rounded">
                <p className="text-center fw-bold mb-2 text-uppercase" style={{ fontSize: "0.65rem", color: "#ffffff" }}>
                  Focus Mancata Vendita
                </p>

                {/* Tabella stilizzata per allineamento perfetto */}
                {[
                  { label: "Valore", attuale: formatToEuro(mancataVenditaAttuale.valore), media: formatToEuro(mancataVenditaMedia.valore), trend: percentualeValore },
                  { label: "Clienti", attuale: mancataVenditaAttuale.num_cli, media: mancataVenditaMedia.num_cli, trend: percentualeNumCli },
                  { label: "Quantità", attuale: mancataVenditaAttuale.qta, media: mancataVenditaMedia.qta, trend: percentualeQta },
                  { label: "Disponibile %", attuale: mancataVenditaAttuale.ricercato_disponibile, media: mancataVenditaMedia.ricercato_disponibile, trend: percentualeDisponibile }
                ].map((row, i) => (
                  <div key={i} className={`d-flex text-light justify-content-between align-items-center py-1 ${i !== 0 ? 'border-top border-white' : ''}`}>
                    <div className="d-flex flex-column" style={{ width: '33%' }}>
                      <span className=" text-light text-uppercase fw-bold x-small-font">{row.label}</span>
                      <span className="fw-bold small text-nowrap">{row.attuale}</span>
                    </div>

                    <div className="text-center text-light d-flex flex-column" style={{ width: '33%' }}>
                      <span className="text-light text-uppercase x-small-font">Media</span>
                      <span className="small text-light text-nowrap">{row.media}</span>
                    </div>

                    <div className="d-flex flex-column text-light align-items-end" style={{ width: '33%' }}>
                      <span className="text-light text-uppercase x-small-font">Trend</span>
                      {renderTrend(row.trend, true)}
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </Card.Body>
      </Card>

      <style>{`
        .responsive-scroll-container {
          width: 100%;
          overflow-x: auto;
          overflow-y: hidden;
          padding: 5px;
        }
        
        /* Nasconde la scrollbar ma permette lo scroll su Chrome/Safari */
        .responsive-scroll-container::-webkit-scrollbar {
          height: 4px;
        }
        .responsive-scroll-container::-webkit-scrollbar-thumb {
          background: #e0e0e0;
          border-radius: 10px;
        }

        .x-small-font {
          font-size: 0.55rem !important;
        }

        .text-nowrap {
          white-space: nowrap;
        }

        @media (max-width: 320px) {
          .ombra.ordini-ora {
            max-width: 300px;
          }
        }


        /* =====================================================
           MODALE MANCATA VENDITA AMOTIVE
           STESSA IMPOSTAZIONE DEL TECHNOPARTS
           IMPORTANTE: DettagliManVenAR.jsx NON VIENE TOCCATO
           ===================================================== */

        /* Backdrop quasi opaco */
        body:has(.modern-modal.show) .modal-backdrop.show {
          opacity: 0.90 !important;
          background: #07090d !important;

          backdrop-filter: none !important;
          -webkit-backdrop-filter: none !important;
        }

        .modern-modal {
          padding: 18px !important;
        }

        .modern-modal .modal-dialog {
          width: min(1380px, calc(100vw - 36px)) !important;
          max-width: 1380px !important;
          margin: 0 auto !important;
        }

        /* Finestra principale */
        .modern-modal .modal-content {
          position: relative;

          width: 100% !important;
          max-height: calc(100dvh - 36px) !important;

          overflow: hidden !important;

          color: #f5f6f8 !important;

          background:
            radial-gradient(
              circle at 0% 0%,
              rgba(241, 111, 36, 0.16),
              transparent 34%
            ),
            radial-gradient(
              circle at 100% 10%,
              rgba(255,255,255,0.04),
              transparent 28%
            ),
            linear-gradient(
              145deg,
              rgba(39,42,49,0.94),
              rgba(20,22,27,0.97)
            ) !important;

          border:
            1px solid rgba(255,255,255,0.11) !important;

          border-radius: 24px !important;

          box-shadow:
            0 34px 88px rgba(0,0,0,0.58),
            inset 0 1px 0 rgba(255,255,255,0.09) !important;

          /* glass leggero, non effetto sfocato pesante */
          backdrop-filter: blur(8px) saturate(115%) !important;
          -webkit-backdrop-filter: blur(8px) saturate(115%) !important;
        }

        /* Riflesso superiore arancio */
        .modern-modal .modal-content::before {
          content: "";

          position: absolute;
          top: 0;
          left: 28px;

          width: 36%;
          height: 1px;

          background:
            linear-gradient(
              90deg,
              #f16f24,
              transparent
            );

          pointer-events: none;
          z-index: 5;
        }

        /* =====================================================
           HEADER
           ===================================================== */

        .modern-modal .modal-header {
          flex: 0 0 auto;

          padding:
            20px
            24px
            14px !important;

          background:
            rgba(255,255,255,0.015) !important;

          border: 0 !important;

          border-bottom:
            1px solid rgba(255,255,255,0.06) !important;
        }

        .modern-modal .modal-title {
          color: #fff !important;

          font-size:
            clamp(1.05rem, 1.5vw, 1.35rem) !important;

          font-weight: 850 !important;

          letter-spacing: -0.02em;
        }

        /* Lo span "Mancata Vendita" già presente nel componente */
        .modern-modal .modal-title span {
          color: #f16f24 !important;
        }

        /* X custom già esistente */
        .modern-modal .modal-header > div:last-child {
          width: 36px;
          height: 36px;

          display: flex;
          align-items: center;
          justify-content: center;

          flex: 0 0 36px;

          color: rgba(255,255,255,0.62) !important;

          background:
            rgba(255,255,255,0.065);

          border:
            1px solid rgba(255,255,255,0.075);

          border-radius: 50%;

          transition:
            color 0.18s ease,
            background 0.18s ease,
            border-color 0.18s ease;
        }

        .modern-modal .modal-header > div:last-child:hover {
          color: #fff !important;

          background:
            rgba(241,111,36,0.15);

          border-color:
            rgba(241,111,36,0.24);
        }

        /* =====================================================
           BODY
           ===================================================== */

        .modern-modal .modal-body {
          padding:
            16px
            20px
            20px !important;

          background: transparent !important;

          overflow-y: auto !important;
          overflow-x: hidden !important;

          /* scroll sì, barra no */
          scrollbar-width: none !important;
          -ms-overflow-style: none !important;
        }

        .modern-modal .modal-body::-webkit-scrollbar {
          display: none !important;

          width: 0 !important;
          height: 0 !important;
        }

        /* =====================================================
           CARD INTERNE
           ===================================================== */

        .modern-modal .modern-card {
          color:
            rgba(255,255,255,0.74) !important;

          background:
            linear-gradient(
              145deg,
              rgba(255,255,255,0.065),
              rgba(255,255,255,0.023)
            ) !important;

          border:
            1px solid rgba(255,255,255,0.08) !important;

          border-radius: 18px !important;

          box-shadow:
            0 15px 34px rgba(0,0,0,0.20),
            inset 0 1px 0 rgba(255,255,255,0.05) !important;

          backdrop-filter:
            blur(5px)
            saturate(108%) !important;

          -webkit-backdrop-filter:
            blur(5px)
            saturate(108%) !important;

          overflow: hidden !important;

          transition:
            transform 0.18s ease,
            border-color 0.18s ease,
            box-shadow 0.18s ease !important;
        }

        .modern-modal .modern-card:hover {
          transform:
            translateY(-1px) !important;

          border-color:
            rgba(241,111,36,0.18) !important;

          box-shadow:
            0 18px 38px rgba(0,0,0,0.24),
            inset 0 1px 0 rgba(255,255,255,0.06) !important;
        }

        .modern-modal .modern-card .card-body {
          color:
            rgba(255,255,255,0.72) !important;

          background:
            transparent !important;
        }

        .modern-modal .text-white-50 {
          color:
            rgba(255,255,255,0.44) !important;
        }

        /* numero grande Visite */
        .modern-modal .stat-value {
          background:
            linear-gradient(
              90deg,
              #f16f24,
              #ff9b5f
            ) !important;

          -webkit-background-clip:
            text !important;

          background-clip:
            text !important;

          -webkit-text-fill-color:
            transparent !important;

          font-weight:
            900 !important;
        }

        /* =====================================================
           TABS
           ===================================================== */

        .modern-modal .nav-tabs {
          display: flex;

          gap: 5px;

          padding: 4px;

          margin-bottom: 14px !important;

          border:
            1px solid rgba(255,255,255,0.07) !important;

          border-radius:
            12px !important;

          background:
            rgba(255,255,255,0.03) !important;
        }

        .modern-modal .nav-tabs .nav-link {
          padding:
            7px
            11px !important;

          color:
            rgba(255,255,255,0.48) !important;

          background:
            transparent !important;

          border:
            0 !important;

          border-radius:
            9px !important;

          font-size:
            0.66rem !important;

          font-weight:
            800 !important;

          transition:
            color 0.16s ease,
            background 0.16s ease;
        }

        .modern-modal .nav-tabs .nav-link:hover {
          color:
            rgba(255,255,255,0.84) !important;

          background:
            rgba(255,255,255,0.045) !important;
        }

        .modern-modal .nav-tabs .nav-link.active {
          color: #fff !important;

          background:
            linear-gradient(
              135deg,
              rgba(241,111,36,0.92),
              rgba(204,77,13,0.90)
            ) !important;

          box-shadow:
            inset 0 1px 0 rgba(255,255,255,0.10),
            0 6px 16px rgba(241,111,36,0.14) !important;
        }

        /* =====================================================
           TABELLE - SCROLLABILI SENZA BARRA
           ===================================================== */

        .modern-modal .scroll-container,
        .modern-modal .table-responsive {
          overflow:
            auto !important;

          scrollbar-width:
            none !important;

          -ms-overflow-style:
            none !important;

          overscroll-behavior:
            contain;
        }

        .modern-modal
        .scroll-container::-webkit-scrollbar,
        .modern-modal
        .table-responsive::-webkit-scrollbar {
          display:
            none !important;

          width:
            0 !important;

          height:
            0 !important;
        }

        .modern-modal .custom-table,
        .modern-modal .table {
          width:
            100% !important;

          margin:
            0 !important;

          color:
            rgba(255,255,255,0.70) !important;

          background:
            transparent !important;
        }

        .modern-modal
        .table
        > :not(caption)
        > *
        > * {
          background:
            transparent !important;

          box-shadow:
            none !important;
        }

        .modern-modal .custom-table thead th,
        .modern-modal .table thead th {
          position:
            sticky;

          top:
            0;

          z-index:
            5;

          padding:
            9px
            10px !important;

          color:
            rgba(255,255,255,0.42) !important;

          background:
            #191c21 !important;

          border:
            0 !important;

          border-bottom:
            1px solid rgba(255,255,255,0.065) !important;

          font-size:
            0.60rem;

          font-weight:
            850;

          letter-spacing:
            0.055em;

          white-space:
            nowrap;
        }

        .modern-modal .custom-table tbody td,
        .modern-modal .table tbody td {
          padding:
            9px
            10px !important;

          color:
            rgba(255,255,255,0.70) !important;

          background:
            transparent !important;

          border:
            0 !important;

          border-bottom:
            1px solid rgba(255,255,255,0.045) !important;

          vertical-align:
            middle;
        }

        .modern-modal .custom-table tbody tr:hover td,
        .modern-modal .table tbody tr:hover td {
          background:
            rgba(255,255,255,0.035) !important;
        }

        /* I vecchi text-warning diventano arancio Amotive */
        .modern-modal .text-warning {
          color:
            #ff8847 !important;
        }

        /* badge percentuale */
        .modern-modal .badge {
          color:
            rgba(255,255,255,0.76) !important;

          background:
            rgba(255,255,255,0.07) !important;

          border:
            1px solid rgba(255,255,255,0.09) !important;
        }

        /* =====================================================
           GRAFICO
           ===================================================== */

        .modern-modal
        .recharts-legend-item-text {
          color:
            rgba(255,255,255,0.62) !important;

          font-size:
            10px !important;
        }

        .modern-modal
        .recharts-default-tooltip {
          color:
            #fff !important;

          background:
            #181b20 !important;

          border:
            1px solid rgba(255,255,255,0.10) !important;

          border-radius:
            11px !important;

          box-shadow:
            0 14px 28px rgba(0,0,0,0.30) !important;
        }

        /* =====================================================
           FOOTER
           ===================================================== */

        .modern-modal .modal-footer {
          flex:
            0 0 auto;

          padding:
            8px
            18px
            14px !important;

          background:
            rgba(255,255,255,0.015) !important;

          border:
            0 !important;

          border-top:
            1px solid rgba(255,255,255,0.055) !important;
        }

        .modern-modal .modal-footer img {
          width:
            140px !important;

          height:
            auto;

          opacity:
            0.90 !important;
        }

        /* =====================================================
           TABLET
           ===================================================== */

        @media screen and (max-width: 991px) {
          .modern-modal {
            padding:
              10px !important;
          }

          .modern-modal .modal-dialog {
            width:
              calc(100vw - 20px) !important;

            max-width:
              none !important;
          }

          .modern-modal .modal-body {
            padding:
              12px !important;
          }
        }

        /* =====================================================
           MOBILE
           ===================================================== */

        @media screen and (max-width: 575px) {
          .modern-modal {
            padding:
              6px !important;
          }

          .modern-modal .modal-dialog {
            width:
              calc(100vw - 12px) !important;
          }

          .modern-modal .modal-content {
            max-height:
              calc(100dvh - 12px) !important;

            border-radius:
              19px !important;
          }

          .modern-modal .modal-header {
            padding:
              15px
              14px
              11px !important;
          }

          .modern-modal .modal-title {
            font-size:
              0.95rem !important;
          }

          .modern-modal .modal-body {
            padding:
              10px !important;
          }

          .modern-modal .nav-tabs {
            flex-wrap:
              nowrap !important;

            overflow-x:
              auto !important;

            scrollbar-width:
              none !important;
          }

          .modern-modal
          .nav-tabs::-webkit-scrollbar {
            display:
              none !important;
          }

          .modern-modal
          .nav-tabs
          .nav-link {
            white-space:
              nowrap;
          }

          .modern-modal .custom-table,
          .modern-modal .table {
            font-size:
              0.64rem !important;
          }

          .modern-modal .stat-value {
            font-size:
              4.2rem !important;
          }

          .modern-modal .modal-footer img {
            width:
              112px !important;
          }
        }
      `}</style>

      <Dettagli showModal={showModal} handleCloseModal={handleCloseModal} />
    </>
  );
}

export default WithHeaderStyledExample;